import React from "react";
import { Stack } from "@mui/material";

import { useGetAllLineItems } from "../../hooks";
import { HubTableTemplate } from "../../components";

import { items, keys } from "./helper";
import { LineItemsTable as WorkOrderTable } from "../CustomerOrdersTable/CustomerOrderLineWorksTable";

export const LineItemsTable = ({
  defaultLocation = 1,
  startDate,
  endDate,
  prefix = "lineItem",
  includeCheckbox = true,
}) => {
  const { data, isLoading } = useGetAllLineItems({
    locationId: defaultLocation,
    startDate,
    endDate,
  });

  const headerProps = { items, includeCheckbox, prefix: "lineItem" };
  const bodyProps = {
    items: data?.rows,
    keys: includeCheckbox ? keys : keys?.filter((k) => k?.value != "isChecked"),
    includeChevron: true,
    RenderElement: WorkOrderTable,
  };
  const props = {
    headerProps,
    bodyProps,
    meta: { ...data?.meta, prefix },
    isLoading,
  };

  return (
    <Stack gap="10px" overflow="hidden">
      <HubTableTemplate id="LineItemsTable" {...props} />
    </Stack>
  );
};

export default LineItemsTable;
